export const DEFAULT_BLUE_BACKGROUND = "rgba(233, 245, 254, 0.16)";
export const YELLOW_BACKGROUND = "rgba(238, 149, 4, 0.04)";
export const RED_BACKGROUND = "rgba(227, 6, 19, 0.04)";
export const GREEN_BACKGROUND = "rgba(96, 152, 51, 0.04)";
